<section class="partners-section">
  <h3 class="section-title">Used By Creators</h3>
  <p class="section-subtitle">
    Join thousands of content creators using our AI technology
  </p>

  <div class="partners-grid">
    @for (partner of partners; track partner.name) {
      <div class="partner-card">
        <div class="partner-avatar" (click)="openPartnerProfile(partner)">
          <img
            [src]="partner.avatar"
            [alt]="partner.name + ' avatar'"
            class="avatar-image"
            loading="lazy"
          />
        </div>
        <div class="partner-info">
          <h4 class="partner-name">{{ partner.name }}</h4>
          <span class="partner-platform">{{ partner.platform }}</span>
        </div>
      </div>
    }
  </div>
  <a class="cta-link" routerLink="/partner-program">
    Join our Creator program and receive free credits and special access →
  </a>
</section>
